function decorateAuraLanes(){
  const colours={'almond-chocolate':'#e9d5e9','almond-roasted':'#e2ebc6','cashew-chocolate':'#f3ddb0','cashew-roasted':'#f0cec0','raisin-chocolate':'#ddd1ea','raisin-masala':'#eedbb4',trail:'#d9e8d1',makhana:'#d8e9e7',popped:'#f2d9b3',chocolate:'#e9d5e9',roasted:'#e2ebc6',masala:'#eedbb4',flavours:'#d8e9e7',packs:'#f3ddb0'};
  document.querySelectorAll('[data-family-filter],[data-mix-filter]').forEach(button=>{
    if(button.querySelector('.aura-lane-art'))return;
    const family=button.dataset.familyFilter||button.dataset.mixFilter;
    button.style.setProperty('--lane-color',colours[family]||'#eadcc7');
    const scope=button.closest('[data-family-shop],[data-mix-builder]');
    const cards=scope?.querySelectorAll('[data-family],[data-mix-product]')||[];
    const card=Array.from(cards).find(card=>family==='all'||(card.dataset.family||card.dataset.mixFamily||card.dataset.familyFilter)===family);
    if(family==='all')button.style.setProperty('--lane-color',getComputedStyle(button).getPropertyValue('--range-colour').trim()||'#eadcc7');
    const source=card?.querySelector('img');
    if(source){const image=document.createElement('img');image.src=source.currentSrc||source.src;image.alt='';image.loading='lazy';image.className='aura-lane-art';button.prepend(image);}
  });
}
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',decorateAuraLanes);else decorateAuraLanes();
document.addEventListener('shopify:section:load',decorateAuraLanes);

/* ── Cart page ───────────────────────────────────────────────────────────
   Drives the /cart steppers over the cart AJAX API so the page never reloads.
   Without JS none of this runs and the native "Update bag" submit still works,
   which is why that button is only hidden from here.                        */
(function(){
  const page=document.querySelector('[data-bag-page]');
  if(!page)return;
  const form=page.querySelector('[data-bag-form]');
  if(!form)return;
  const money=paise=>'₹'+(paise/100).toLocaleString('en-IN',{maximumFractionDigits:0});
  const update=page.querySelector('[data-bag-update]');
  if(update)update.hidden=true;
  let busy=false;

  const paint=cart=>{
    if(!cart.items.length){location.reload();return}
    const keys=new Set(cart.items.map(item=>item.key));
    page.querySelectorAll('[data-bag-line]').forEach(line=>{
      if(!keys.has(line.dataset.bagLine))line.remove();
    });
    cart.items.forEach(item=>{
      const line=page.querySelector('[data-bag-line="'+CSS.escape(item.key)+'"]');
      if(!line)return;
      const qty=line.querySelector('[data-bag-qty]');
      if(qty)qty.value=item.quantity;
      const total=line.querySelector('[data-bag-line-total]');
      if(total)total.textContent=money(item.final_line_price);
    });
    const subtotal=page.querySelector('[data-cart-subtotal]');
    if(subtotal)subtotal.textContent=money(cart.total_price);
    const progress=page.querySelector('[data-shipping-progress]');
    if(progress)progress.style.width=Math.min(100,cart.total_price/499)+'%';
    const message=page.querySelector('[data-shipping-message]');
    if(message)message.textContent=cart.total_price>=49900?'You unlocked free shipping!':'Add '+money(49900-cart.total_price)+' for free shipping.';
    const estimator=page.querySelector('[data-delivery-estimator]');
    if(estimator)estimator.dataset.subtotal=cart.total_price;
    document.querySelectorAll('[data-cart-count]').forEach(el=>{el.textContent=cart.item_count});
    const region=document.querySelector('#cart-live-region');
    if(region)region.textContent='Bag updated. Subtotal '+money(cart.total_price);
  };

  const change=async(key,quantity)=>{
    if(busy)return;
    busy=true;page.classList.add('is-busy');
    try{
      const response=await fetch(window.Shopify.routes.root+'cart/change.js',{
        method:'POST',
        headers:{'Content-Type':'application/json'},
        body:JSON.stringify({id:key,quantity:quantity})
      });
      paint(await response.json());
    }catch(error){console.warn(error);location.reload()}
    busy=false;page.classList.remove('is-busy');
  };

  const quantityOf=key=>{
    const field=page.querySelector('[data-bag-qty="'+CSS.escape(key)+'"]');
    return field?Number(field.value)||0:0;
  };

  page.addEventListener('click',event=>{
    const plus=event.target.closest('[data-bag-plus]');
    const minus=event.target.closest('[data-bag-minus]');
    const remove=event.target.closest('[data-bag-remove]');
    if(plus){event.preventDefault();change(plus.dataset.bagPlus,quantityOf(plus.dataset.bagPlus)+1)}
    if(minus){event.preventDefault();change(minus.dataset.bagMinus,Math.max(0,quantityOf(minus.dataset.bagMinus)-1))}
    if(remove){event.preventDefault();change(remove.dataset.bagRemove,0)}
  });

  page.addEventListener('change',event=>{
    const field=event.target.closest('[data-bag-qty]');
    if(field)change(field.dataset.bagQty,Math.max(0,Number(field.value)||0));
  });
})();

// Oct 2026 — product shelves (home Best Sellers / New Arrivals, popped base carousels): arrows + progress bar.
(function(){
  document.querySelectorAll('[data-shelf]').forEach(shelf=>{
    const track=shelf.querySelector('[data-shelf-track]');if(!track)return;
    const prev=shelf.querySelector('[data-shelf-prev]'),next=shelf.querySelector('[data-shelf-next]'),bar=shelf.querySelector('[data-shelf-progress]');
    const sync=()=>{
      const max=track.scrollWidth-track.clientWidth;
      if(prev)prev.disabled=track.scrollLeft<=4;
      if(next)next.disabled=track.scrollLeft>=max-4;
      if(bar){const visible=Math.min(1,track.clientWidth/Math.max(1,track.scrollWidth));bar.style.width=(visible*100)+'%';bar.style.transform=`translateX(${track.scrollLeft/Math.max(1,track.clientWidth)*100}%)`;bar.parentElement.hidden=max<=4}
    };
    const step=dir=>track.scrollBy({left:dir*Math.max(240,track.clientWidth*.8),behavior:'smooth'});
    if(prev)prev.addEventListener('click',()=>step(-1));
    if(next)next.addEventListener('click',()=>step(1));
    track.addEventListener('scroll',sync,{passive:true});
    window.addEventListener('resize',sync);
    sync();
  });
})();

// Oct 2026 — PDP always-on buy bar: mirror the selected size/price, and run "Buy now" when GoKwik isn't claiming it.
(function(){
  const bar=document.querySelector('[data-pdp-float]');if(!bar)return;
  const form=bar.closest('form');
  const price=bar.querySelector('[data-float-price]'),label=bar.querySelector('[data-float-variant]'),add=bar.querySelector('[data-float-add]');
  form.addEventListener('change',event=>{
    const input=event.target.closest('.pdp-variant-chip input');if(!input||!input.checked)return;
    const available=input.dataset.available==='true';
    if(price)price.textContent=input.dataset.money||'';
    const title=input.closest('label')?.querySelector('span')?.textContent?.trim();
    if(label&&title)label.textContent=title+' · ';
    if(add){add.disabled=!available;add.textContent=available?'Add to bag':'Sold out'}
    const buy=bar.querySelector('[data-float-buy]');if(buy&&!buy.classList.contains('gokwik-marge'))buy.disabled=!available;
  });
  document.addEventListener('click',async event=>{
    const buy=event.target.closest('[data-float-buy]');
    if(!buy||buy.classList.contains('gokwik-marge')||buy.disabled)return; // GoKwik owns claimed buttons
    event.preventDefault();
    const native=form.querySelector('.pdp-buy-now .shopify-payment-button__button');
    if(native&&native.offsetParent!==null){native.click();return}
    buy.disabled=true;
    try{
      const response=await fetch(`${window.Shopify.routes.root}cart/add.js`,{method:'POST',headers:{Accept:'application/json'},body:new FormData(form)});
      if(!response.ok)throw new Error('add failed');
      window.location.href=`${window.Shopify.routes.root}checkout`;
    }catch(error){buy.disabled=false;form.requestSubmit?.()}
  });
})();
